import {
  IDynamicDiplayView,
  IDynamicSection
} from '@components/widgets/dynamic-display';
import { EnhancedDisplayType } from '@components/widgets/dynamic-display/EnhancedDisplay';
import { capitalizeFirstCharLowerOthers } from '@utils/formatting-utils';

import { PolicyExpat } from '../types';

export function buildPolicyExpatDetailsView(
  data: PolicyExpat[]
): IDynamicDiplayView {
  return {
    name: 'ExpatDetails',
    sections: data.map<IDynamicSection>((item, index) => ({
      name: `PolicyDetails_${index}`,
      title: `Expat Details`,
      properties: {
        gender: {
          name: 'gender',
          title: 'Gender',
          value: capitalizeFirstCharLowerOthers(item?.gender) || '',
          hidden: false,
          multiline: false
        },
        dateOfBirth: {
          name: 'dateOfBirth',
          title: 'Date of Birth',
          value: item?.dateOfBirth || '',
          type: EnhancedDisplayType.Date,
          hidden: false,
          multiline: false
        },
        nationality: {
          name: 'nationality',
          title: 'Nationality',
          value: item?.nationality?.title || '',
          hidden: false,
          multiline: false
        },
        occupationClass: {
          name: 'occupationClass',
          title: 'Occupation Class',
          value: item?.occupationClass?.title || '',
          hidden: false,
          multiline: false
        },
        medicalClass: {
          name: 'medicalClass',
          title: 'Medical Class',
          value: item?.medicalClass?.title || '',
          hidden: false,
          multiline: false
        },
        emergency: {
          name: 'emergency',
          title: 'Emergency',
          value: capitalizeFirstCharLowerOthers(item?.emergency) || '',
          hidden: false,
          multiline: false
        },
        continuity: {
          name: 'continuity',
          title: 'Continuity',
          value: item?.continuity ? 'Yes' : 'No',
          hidden: false,
          multiline: false
        },
        continuityNumber: {
          name: 'continuityNumber',
          title: 'Continuity Number',
          value: item?.continuityNumber || '',
          hidden: false,
          multiline: false
        },
        exclusion: {
          name: 'exclusion',
          title: 'Exclusion',
          value: item?.exclusion || '',
          hidden: false,
          multiline: true,
          fullLine: true
        },
        remarks: {
          name: 'remarks',
          title: 'Remarks',
          value: item?.remarks || '',
          hidden: false,
          multiline: true,
          fullLine: true
        }
      }
    }))
  };
}
